module.exports = __webpack_public_path__ + "static/media/Barlow-Light.2f88cf87.ttf";